import { Route, useLocation } from 'react-router-dom';

import { useFeatureFlag } from './lib/configcat';

export const V2Route = ({ flag, path, render, v2Path, ...rest }) => {
  const [enabled, loading] = useFeatureFlag(flag);
  const location = useLocation();

  if (loading) {
    return null;
  }

  // If enabled, redirect to /v2 version
  if (enabled) {
    const redirectPath = v2Path || `/v2${location.pathname}${location.search}${location.hash}`;

    window.location.href = redirectPath;

    return <></>;
  }

  // Otherwise render Route normally
  return <Route path={path} render={render} {...rest} />;
};
